import React, { useEffect, useMemo, useState } from 'react';
import { Alert, Checkbox, DatePicker, Modal, Select, Space, Typography } from 'antd';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;
const { Text } = Typography;

const AdsCostSyncModal = ({
  open,
  loading,
  sellerAccounts = [],
  initialSellerAccountIds = [],
  initialRange,
  onCancel,
  onSubmit,
}) => {
  const allAccountIds = useMemo(
    () => sellerAccounts.map(account => account.id),
    [sellerAccounts]
  );
  const accountOptions = useMemo(() => sellerAccounts.map(account => ({
    value: account.id,
    label: account.name || account.sellerId,
  })), [sellerAccounts]);
  const [sellerAccountIds, setSellerAccountIds] = useState([]);
  const [dateRange, setDateRange] = useState(null);

  useEffect(() => {
    if (!open) return;
    setSellerAccountIds(initialSellerAccountIds.length ? initialSellerAccountIds : allAccountIds);
    setDateRange(initialRange?.length === 2
      ? [dayjs(initialRange[0]), dayjs(initialRange[1])]
      : null);
  }, [allAccountIds, initialRange, initialSellerAccountIds, open]);

  const selectAll = sellerAccountIds.length === allAccountIds.length && allAccountIds.length > 0;
  const indeterminate = sellerAccountIds.length > 0 && sellerAccountIds.length < allAccountIds.length;
  const rangeDays = dateRange?.[0] && dateRange?.[1]
    ? dateRange[1].startOf('day').diff(dateRange[0].startOf('day'), 'day') + 1
    : 0;
  const rangeInvalid = rangeDays > 31;
  const canSubmit = sellerAccountIds.length > 0
    && dateRange?.[0]
    && dateRange?.[1]
    && !rangeInvalid;

  return (
    <Modal
      title="Đồng bộ Amazon Ads Cost"
      open={open}
      onCancel={onCancel}
      onOk={() => onSubmit({
        sellerAccountIds,
        startDate: dateRange[0].format('YYYY-MM-DD'),
        endDate: dateRange[1].format('YYYY-MM-DD'),
      })}
      okText="Bắt đầu đồng bộ"
      cancelText="Hủy"
      okButtonProps={{ disabled: !canSubmit }}
      confirmLoading={loading}
      destroyOnClose
      width={620}
    >
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Alert
          type="info"
          showIcon
          message="Dữ liệu được đồng bộ ở chế độ nền"
          description="Hệ thống sẽ chuyển job về worker riêng của từng Seller Account. Báo cáo hiện tại không tự tải lại ngay sau khi job được tạo."
        />

        <div>
          <Text strong>Khoảng thời gian</Text>
          <RangePicker
            value={dateRange}
            onChange={setDateRange}
            allowClear={false}
            format="DD/MM/YYYY"
            style={{ width: '100%', marginTop: 8 }}
          />
          <Text type={rangeInvalid ? 'danger' : 'secondary'} style={{ display: 'block', marginTop: 4 }}>
            Amazon Ads hỗ trợ tối đa 31 ngày cho mỗi lần đồng bộ.
          </Text>
        </div>

        <div>
          <Space style={{ marginBottom: 8 }}>
            <Text strong>Seller Account</Text>
            <Checkbox
              checked={selectAll}
              indeterminate={indeterminate}
              onChange={event => setSellerAccountIds(event.target.checked ? allAccountIds : [])}
            >
              Chọn tất cả
            </Checkbox>
          </Space>
          <Select
            mode="multiple"
            allowClear
            maxTagCount="responsive"
            value={sellerAccountIds}
            options={accountOptions}
            onChange={setSellerAccountIds}
            placeholder="Chọn Seller Account"
            style={{ width: '100%' }}
          />
        </div>
      </Space>
    </Modal>
  );
};

export default AdsCostSyncModal;
